export const IMAGE_STORAGE_URL = `${process.env.MIX_IMAGE_STORAGE_URL}`;
export const CHATBOX_SERVICE_URL = `${process.env.MIX_CHATBOX_SERVICE_URL}`;
export const COMMENT_API_URL = `${process.env.MIX_COMMENT_API_URL}`;

export const EVENT_ODDS_LIVE_DATA_UPDATED = 'ODDS_LIVE_DATA_UPDATED';
